module.exports = __webpack_public_path__ + "img/add_video_af.dc218052.svg";